import Vue from 'vue';
import { getWebSocketUrl } from '../config/environment'

let socket = null;

const emitter = new Vue({
  data() {
    return {
      socketUrl: this.resolveWebSocketUrl(),
    };
  },
  methods: {
    resolveWebSocketUrl() {
      // Use WS_URL from environment configuration (loaded from .env file)
      const wsUrl = getWebSocketUrl()
      if (!wsUrl) {
        console.error('❌ WS_URL not found in .env file. Please create .env file with WS_URL variable.')
      }
      return wsUrl
    },
    connect() {
      if (socket && [WebSocket.OPEN, WebSocket.CONNECTING].includes(socket.readyState)) {
        console.log('WebSocket is already connected or connecting.');
        return;
      }

      socket = new WebSocket(this.socketUrl);
      socket.onopen = () => this.$emit('open', 'Socket is open.');
      socket.onmessage = (msg) => this.$emit('message', msg.data);
      socket.onerror = (err) => this.$emit('error', err);
      socket.onclose = (err) => {
        this.$emit('close', 'Socket is closed.');
        socket = null; // Reset socket to null to allow reconnection
      };
    },
    send(message) {
      // Log the request being sent to socket
      console.log('SENDING REQUEST TO SOCKET', message);
      
      if (socket && socket.readyState === WebSocket.OPEN) {
        socket.send(JSON.stringify(message));
      } else {
        console.log('Socket is not open. Connecting...');
        this.connect();
        setTimeout(() => {
          if (socket.readyState === WebSocket.OPEN) {
            console.log('SENDING REQUEST TO SOCKET (after reconnect)', message);
            socket.send(JSON.stringify(message));
          } else {
            console.log('Failed to open socket after waiting.');
          }
        }, 2000); // Consider a more robust retry mechanism
      }
    },
    close() {
      if (socket && socket.readyState === WebSocket.OPEN) {
        socket.close();
      }
    },
  },
  created() {
    this.connect(); // Optionally auto-connect on creation
  },
});

export default emitter;



// WEBPACK FOOTER //
// ./src/services/Socket.js